import { render, staticRenderFns } from "./device_stats.vue?vue&type=template&id=201a64e5&scoped=true&"
import script from "./device_stats.vue?vue&type=script&lang=js&"
export * from "./device_stats.vue?vue&type=script&lang=js&"
import style0 from "./device_stats.vue?vue&type=style&index=0&id=201a64e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a64e5",
  null
  
)

export default component.exports